var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413,99a221.83,221.83,0,0,0-313-.76V49H70v105H175V124h-58.4A191.8,191.8,0,0,1,256,63.92c105.91,0,192.08,86.17,192.08,192.08S361.91,448.08,256,448.08,63.92,361.91,63.92,256H34A222,222,0,0,0,413,413a222,222,0,0,0,0-314Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind);
export default __webpack_public_path__ + "static/media/rewind.e2d94bef4edc50802ed942fcbf5e5994.svg";
export { ForwardRef as ReactComponent };